export default "__VITE_ASSET__Cz1xzxjc__"